import { stringify, parse } from 'query-string';
import { getIn } from 'seamless-immutable';

export const getMoreOffersUrl = (productId, currentSku = {}, locationQuery = '') => {
  const currentQuery = parse(locationQuery?.replace('?', ''));
  const query = {};
  const skuId = currentSku.id;
  const offerId = getIn(currentSku, ['offers', 'result', '0', 'id']);

  if (offerId) {
    query.offerId = offerId;
  }
  query.productSku = skuId;
  const querystring = stringify({ ...currentQuery, ...query });

  return `/parceiros/${productId}?${querystring}`;
};
